import { render, staticRenderFns } from "./DeletionDialog.vue?vue&type=template&id=b8e58b34"
import script from "./DeletionDialog.vue?vue&type=script&lang=js"
export * from "./DeletionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports